/**
 * @generated SignedSource<<2a20e50ef7e9e2a30542a9976da36060>>
 * @relayHash 7b455385190f73826883a146bbab20e6
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7b455385190f73826883a146bbab20e6

import { ConcreteRequest } from 'relay-runtime';
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type insureeDataFromSasisBySocialSecurityNumberQuery$variables = {
  socialSecurityNumber: string;
};
export type insureeDataFromSasisBySocialSecurityNumberQuery$data = {
  readonly ch_insureeDataFromSasisBySocialSecurityNumberAtEveryInsurer: {
    readonly organisationResults: ReadonlyArray<{
      readonly errorMessage: string | null;
      readonly nationalInsuranceNumber: number;
      readonly organisationName: string;
      readonly result: {
        readonly mapped: {
          readonly address: {
            readonly city: string;
            readonly countryCode: string;
            readonly houseNumberStreet: string;
            readonly postalCode: string;
          };
          readonly dateOfBirth: any;
          readonly firstName: string;
          readonly gatekeeperZsr: string | null;
          readonly gender: Gender;
          readonly healthInsurance: string;
          readonly insuranceCardNumber: string;
          readonly insureeNumber: string;
          readonly isPrimary: boolean;
          readonly lastName: string;
          readonly nationalInsuranceNumber: number;
          readonly socialSecurityNumber: string | null;
          readonly validFrom: any;
          readonly validTo: any;
        } | null;
        readonly rawXml: string | null;
        readonly returnCode: string | null;
        readonly returnMessage: string | null;
      } | null;
    }>;
  };
};
export type insureeDataFromSasisBySocialSecurityNumberQuery = {
  response: insureeDataFromSasisBySocialSecurityNumberQuery$data;
  variables: insureeDataFromSasisBySocialSecurityNumberQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "socialSecurityNumber"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationalInsuranceNumber",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "socialSecurityNumber",
        "variableName": "socialSecurityNumber"
      }
    ],
    "concreteType": "SasisAhvLookupResult",
    "kind": "LinkedField",
    "name": "ch_insureeDataFromSasisBySocialSecurityNumberAtEveryInsurer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SasisAhvLookupOrganisationResult",
        "kind": "LinkedField",
        "name": "organisationResults",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organisationName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SasisLookupResult",
            "kind": "LinkedField",
            "name": "result",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PatientInsuranceCardDetails",
                "kind": "LinkedField",
                "name": "mapped",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateOfBirth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gender",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "insureeNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "insuranceCardNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "socialSecurityNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "healthInsurance",
                    "storageKey": null
                  },
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPrimary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gatekeeperZsr",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "validFrom",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "validTo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "address",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "houseNumberStreet",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "postalCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "countryCode",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rawXml",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "returnCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "returnMessage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "insureeDataFromSasisBySocialSecurityNumberQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "insureeDataFromSasisBySocialSecurityNumberQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "7b455385190f73826883a146bbab20e6",
    "metadata": {},
    "name": "insureeDataFromSasisBySocialSecurityNumberQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "eed9bda144d02da0edd9bfc209540623";

export default node;
